// extracted by mini-css-extract-plugin
export const container = "footer-module--container--OMGFv";
export const links = "footer-module--links--SBoQq";
export const footer = "footer-module--footer--2fS57";